import {inject, Service} from '@angular/core'
import {ActivatedRoute, ParamMap} from '@angular/router'
import {environment} from '../../environments/environment'
import {ControlService} from './control.service'

@Service()
export class TestService {
  private readonly route = inject(ActivatedRoute)
  private readonly controlService = inject(ControlService)


  public showTestData = environment.testMode

  public linear = false

  constructor() {
    this.route.queryParamMap.subscribe((paramsMap: ParamMap) => {
      if (paramsMap.get('index')) {
        // This happens before we have selected a new selection and is
        // therefore overriddden by the loading of customer
        this.controlService.step$.next(Number.parseInt(paramsMap.get('index') as string, 10))
      }
    })
  }
}
